import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import {mergeClasses} from 'minimal-shared/utils';
import {ReactNode, useEffect} from 'react';
import {useLocation} from 'react-router';

import {Logo} from '@minimal/components/logo';
import type {NavSectionProps} from '@minimal/components/nav-section';
import {NavSectionVertical} from '@minimal/components/nav-section';
import {Scrollbar} from '@minimal/components/scrollbar';
import {NavAppEnv} from '@minimal/layouts/components/nav-app-env';
import {WorkspacesPopover} from '@minimal/layouts/components/workspaces-popover';

import {layoutClasses} from '../core/classes';

// ----------------------------------------------------------------------

type NavMobileProps = NavSectionProps & {
  open: boolean;
  onClose: () => void;
  slots?: {
    topArea?: ReactNode;
    bottomArea?: ReactNode;
  };
};

export function NavMobile({open, onClose, slots, sx, className, ...other}: NavMobileProps) {
  const location = useLocation();

  useEffect(() => {
    if (open) {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      PaperProps={{
        className: mergeClasses([layoutClasses.nav.root, layoutClasses.nav.vertical, className]),
        sx: [
          () => ({
            overflow: 'unset',
            bgcolor: 'var(--layout-nav-bg)',
            width: 'var(--layout-nav-mobile-width)',
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ],
      }}
    >
      {slots?.topArea ?? (
        <Box sx={{px: 3.5, pt: 2.5, pb: 1, textAlign: 'center'}}>
          <Logo isSingle={false} />
        </Box>
      )}

      <NavAppEnv sx={{mx: 2, mt: 2.5, mb: 1}} />

      <Box sx={{px: 3.5, pt: 2.5, pb: 1}}>
        <WorkspacesPopover />
      </Box>

      <Scrollbar fillContent>
        <NavSectionVertical sx={{px: 2, flex: '1 1 auto'}} {...other} />
      </Scrollbar>

      {slots?.bottomArea}
    </Drawer>
  );
}
